module.exports = __webpack_public_path__ + "fonts/icomoon.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon/icomoon.woff
// module id = 1Vz3
// module chunks = 1